// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__6UHJd","large":"styles_large__2RLDH"};